import {
  Navigate,
} from 'react-big-calendar';

import {
  Button,
} from 'web-components';
import {
  Flex,
  Text,
  SVG,
} from 'web-styled';

type Props = {
  label: string,
  onNavigate: { (date: any): void },
}

export default ({
  onNavigate,
  label,
}: Props) => (
  <Flex
    align="center"
    padding="10px"
    spacing={40}
  >
    <Flex align="center" spacing={8}>
      <Button
        ghost
        circled
        appearance="primary"
        icon={<SVG.ChevronLeft size={14} />}
        onClick={() => onNavigate(Navigate.PREVIOUS)}
      />
      <Button
        ghost
        circled
        appearance="primary"
        icon={<SVG.ChevronRight size={14} />}
        onClick={() => onNavigate(Navigate.NEXT)}
      />
    </Flex>
    <Text
      weight={500}
      size="30px"
    >
      {label}
    </Text>
  </Flex>
);
